import React from 'react';
import PropTypes from 'prop-types';

const SectionWrapper = ({ children, header, description, className = '', headerClassName = '', buttonClassName = '', secondaryButtonClassName = '', button, secondaryButton }) => (
  <div className='col-12'>
    <div className={`row pb-3 ${className}`}>
      <div className='col'>
        <div className={`fs-3 ${headerClassName}`}>{header}</div>
        {description && <div dangerouslySetInnerHTML={{ __html: description }} />}
      </div>
      {secondaryButton &&
      <div className={`col-auto ${secondaryButtonClassName}`}>
        {secondaryButton}
      </div>
      }
      <div className={`col-auto ${buttonClassName}`}>
        {button}
      </div>
    </div>

    <div className=''>
      {children}
    </div>
  </div>
);

SectionWrapper.propTypes = {
  header: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.string,
  ]),
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
  headerClassName: PropTypes.string,
  description: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.string,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.bool,
    ])),
    PropTypes.element,
  ]),
  button: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.string,
  ]),
  secondaryButton: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.string,
  ]),
  secondaryButtonClassName: PropTypes.string,
};

export default SectionWrapper;
